export const SIGNUP_STATUS = 'SIGNUP_STATUS';
export const FETCH_SUBMISSIONS = 'FETCH_SUBMISSIONS';
export const EDIT_SUBMISSION = 'EDIT_SUBMISSION';

export const UNLOCK_BIND= 'submission/UNLOCK_SUBMISSION';
export const LOCK_BIND= 'submission/LOCK_SUBMISSION';

export const CHANGE_SUBMISSION_STATUS = 'submission/CHANGE_SUBMISSION_STATUS';
export const CHANGE_SUBMISSION = 'submission/CHANGE_SUBMISSION';
export const CHANGE_SUBMISSION_PARAMS = 'submission/CHANGE_SUBMISSION_PARAMS';
export const CLEAR_SUBMISSION = 'submission/CLEAR_SUBMISSION';
export const CHANGE_SUBMISSION_COVERAGE = 'submission/CHANGE_COVERAGE_OPTION';
export const CHANGE_SUBMISSION_RELATED_ENTITIES = 'submission/CHANGE_SUBMISSION_RELATED_ENTITIES';
export const CHANGE_AI_FORMS = 'submission/CHANGE_AI_FORMS';
export const CHANGE_AI_LIST = 'submission/CHANGE_AI_LIST';

export const LOAD_ARGOPI ='submission/LOAD_ARGOPI';
export const LOAD_ARGOPI_SUCCESS ='submission/LOAD_ARGOPI_SUCCESS';
export const LOAD_ARGOPI_FAILURE ='submission/LOAD_ARGOPI_FAILURE';
export const LOAD_ARGOPI_RESET ='submission/LOAD_ARGOPI_RESET';

export const SUBMISSION_CLEARANCE_FAILED = 'submission/CLEARANCE_FAILED';
export const SUBMISSION_CLEARANCE_PASSED = 'submission/CLEARANCE_PASSED';
export const SUBMISSION_CLEARANCE_PENDING = 'submission/CLEARANCE_PENDING';
export const SUBMISSION_QUOTED = 'submission/SUBMISSION_QUOTED';
export const SUBMISSION_KNOCKED_OUT = 'submission/SUBMISSION_KNOCKED_OUT';
export const SUBMISSION_FAILED = 'submission/SUBMISSION_FAILED';

export const SUBMISSION_CREATE = 'submission/SUBMISSION_CREATE';
export const SUBMISSION_CREATE_FAILED = 'submission/SUBMISSION_CREATE_FAILED';
export const SUBMISSION_CREATE_SUCCESS = 'submission/SUBMISSION_CREATE_SUCCESS';

export const SUBMISSION_EDIT = 'submission/SUBMISSION_EDIT';
export const SUBMISSION_EDIT_FAILED = 'submission/SUBMISSION_EDIT_FAILED';
export const SUBMISSION_EDIT_SUCCESS = 'submission/SUBMISSION_EDIT_SUCCESS';
export const SUBMISSION_EXCESS_SELECTION = 'submission/SUBMISSION_EXCESS_SELECTION';
export const CREATE_RELATED_SUBMISSION = 'submission/CREATE_RELATED_SUBMISSION';
export const CLEAR_AND_CHANGE_SUBMISSION = 'submission/CLEAR_AND_CHANGE_SUBMISSION';
export const GET_SUBMISSION = 'submission/GET_SUBMISSION';
export const SAVE_SUBMISSION = 'submission/SAVE_SUBMISSION';
export const SUBMISSION_LIMIT_CHANGE = 'submission/LIMIT_CHANGE';
export const SUBMISSION_ADJUSTED_COMMISSION_CHANGE = 'submission/ADJUSTED_COMMISSION_CHANGE';
export const SUBMISSION_UPDATE_WORKFLOW_LIMIT_CHANGE = 'submission/UPDATE_WORKFLOW_LIMIT_CHANGE';
export const SUBMISSION_UPDATE_WORKFLOW_COVERAGE_CHANGE = 'submission/UPDATE_WORKFLOW_COVERAGE_CHANGE';
export const SUBMISSION_UPDATE_WORKFLOW_INCLUDED_CHANGE = 'submission/UPDATE_WORKFLOW_INCLUDED_CHANGE';
export const SUBMISSION_UPDATE_ADDL_DOCS_ID = 'submission/SUBMISSION_UPDATE_ADDL_DOCS_ID';
export const SUBMISSION_UPDATE_IS_EXCESS_ONLY = 'submission/SUBMISSION_UPDATE_IS_EXCESS_ONLY';
export const SUBMISSION_UPDATE_BY_KEY = 'submission/SUBMISSION_UPDATE_BY_KEY'

export const SUBMISSION_DIALOG_STATUS = {
    CONFIRMATION: 'CONFIRMATION',
    REQUIRED: 'REQUIRED',
    CANCEL: 'CANCEL',
    NONE: 'NONE'
};
export const SUBMISSION_STATUS = {
    NONE: 'NONE',
    SELECTION: 'SELECTION',
    CLEARANCE: 'CLEARANCE',
    EDIT: 'EDIT',
    CREATING: 'CREATING',
    REVIEW: 'REVIEW',
    QUOTE: 'QUOTE'
};

export const INITIAL_SUBMISSION_STATE = 'submission/INITIAL_SUBMISSION_STATE';
export const SET_SUBMISSION_AND_DIALOG_STATUS = 'submission/SET_SUBMISSION_AND_DIALOG_STATUS';
export const CHANGE_SUBMISSION_DIALOG_STATUS = 'submission/CHANGE_SUBMISSION_DIALOG_STATUS';
export const SET_SUBMISSION_DIALOG_STATUS = 'submission/SET_SUBMISSION_DIALOG_STATUS';
export const SUBMIT_SUBMISSION_QUOTE = 'submission/SUBMIT_SUBMISSION_QUOTE';
export const SUBMISSION_SUBMIT_FOR_REVIEW = 'submission/SUBMISSION_SUBMIT_FOR_REVIEW';
export const FETCH_PRE_CLEARED_SUBMISSION = 'submission/FETCH_PRE_CLEARED_SUBMISSION';
export const SUBMISSION_CHANGE_PRICING_VALUE = 'submission/CHANGE_PRICING_VALUE';
export const SUBMISSION_UPDATE = 'submission/SUBMISSION_UPDATE';
export const SUBMISSIONS_REFETCH = 'submission/SUBMISSIONS_REFETCH';
export const DOWNLOAD_SUBMISSION_QUOTE = 'submission/DOWNLOAD_SUBMISSION_QUOTE';
export const DOWNLOAD_SUBMISSION_QUOTE_SPECIMEN = 'submission/DOWNLOAD_SUBMISSION_QUOTE_SPECIMEN';
export const DOWNLOAD_SUBMISSION_REVISION_QUOTE = 'submission/DOWNLOAD_SUBMISSION_REVISION_QUOTE';
export const SUBMISSION_UPDATE_WORKFLOW_STATUS_CHANGE = 'submission/UPDATE_WORKFLOW_STATUS_CHANGE';
export const SUBMISSION_UPDATE_BIND_STATUS_CHANGE = 'submission/UPDATE_BIND_STATUS_CHANGE';
export const SUBMISSION_SET_ISBINDED = 'submission/SET_ISBINDED';
export const SUBMISSION_SET_ISBINDERSAVED = 'submission/SET_ISBINDERSAVED';
export const GET_PDF_ARRAY = 'submission/GET_PDF_ARRAY';
export const SUBMISSION_UPDATE_RATING_OPTION = 'submission/UPDATE_RATING_OPTION';
export const SUBMISSION_UPDATE_MANUAL_QUOTE_STATUS_FOR_ID = 'submission/UPDATE_MANUAL_QUOTE_STATUS_FOR_ID';
export const SUBMISSION_UPDATE_MANUAL_QUOTE_STATUS = 'submission/UPDATE_MANUAL_QUOTE_STATUS';